export const shouldBeNumber = (value: unknown): boolean => {
  const num = Number(value);
  return value !== undefined && value !== null && String(num) === String(value) && !isNaN(num);
};
